document.addEventListener("DOMContentLoaded", function () {
    var contentArea = document.querySelector(".article-template__content");
    if (!contentArea) return;

    var headings = contentArea.querySelectorAll("h2, h3");
    var tocList = document.getElementById("toc-list");
    if (!tocList) return;

    headings.forEach(function (heading, index) {
        var id = "toc-heading-" + index;
        heading.id = id;

        var tocItem = document.createElement("li");
        var tocLink = document.createElement("a");
        tocLink.href = "#" + id;
        tocLink.textContent = heading.textContent;

        tocItem.appendChild(tocLink);
        tocList.appendChild(tocItem);
    });
});
